// extracted by mini-css-extract-plugin
export default {"dashedButton":"SharedEmptyPicker-module__dashedButton--MFDKV","hotkeyBadge":"SharedEmptyPicker-module__hotkeyBadge--NXUA9"};